import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogues } from "../../../../store/catalogue/actions";
export var useGetCatalog = function (trigger, parentCatalogueId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseCatalogues: (_a = state.Catalogues.responseCatalogues) === null || _a === void 0 ? void 0 : _a.data,
            loadingCatalogues: state.Catalogues.loadingCatalogues,
            errorCatalogues: state.Catalogues.errorCatalogues,
        });
    }), responseCatalogues = _a.responseCatalogues, loadingCatalogues = _a.loadingCatalogues, errorCatalogues = _a.errorCatalogues;
    useEffect(function () {
        if (trigger && parentCatalogueId) {
            dispatch(getCatalogues({
                enable: true,
                page: 1,
                limit: 1000,
                parentCatalogId: parentCatalogueId,
            }));
        }
    }, [trigger, parentCatalogueId]);
    return {
        responseCatalogues: responseCatalogues,
        loadingCatalogues: loadingCatalogues,
        errorCatalogues: errorCatalogues,
    };
};
